import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import FormField from "@/components/Forms/FormField.vue";
import {watch, reactive} from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ShippingAddress',
  props: {
  data: {
    type: Object,
  },
  color: {
    type: String,
  },
  buttonColor: {
    type: String,
  },
  edit: {
    type: Boolean,
    default: false
  }
},
  emits: ['save', 'edit', 'close'],
  setup(__props, { emit: __emit }) {

const defaultData = {
  address_1: '-',
  address_2: '-',
  address_3: '-',
  city: '-',
  county: '-',
  country: '-',
  post_code: '-',
};

const props = __props

const emit = __emit

const state = reactive({
  ...defaultData, // Initialize with default data first
});

// Watch for changes in props.data to update state
watch(() => props.data, (newData) => {
  if (!newData) return; // Return early if data is undefined
  Object.keys(defaultData).forEach(key => {
    state[key] = newData[key] !== undefined && newData[key] !== null ? newData[key] : defaultData[key];
  });
}, {immediate: true});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    class: "px-5 py-3",
    style: {"background-color":"#F5F5F5"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "px-3 mb-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createElementVNode("p", { class: "p-text-lg mt-2" }, "Shipping Address", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "text-right" }, {
            default: _withCtx(() => [
              (!__props.edit)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    color: "#F5F5F5",
                    variant: "flat",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('edit')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: __props.color,
                        icon: "fa fa-pencil"
                      }, null, 8, ["color"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    color: "#F5F5F5",
                    variant: "flat",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('save', { ...state, client_id: __props.data?.client_id, id: __props.data?.id })))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: __props.buttonColor,
                        icon: "fas fa-save"
                      }, null, 8, ["color"])
                    ]),
                    _: 1
                  })),
              (__props.edit)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 2,
                    color: "#F5F5F5",
                    variant: "flat",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: __props.color,
                        icon: "fas fa-close"
                      }, null, 8, ["color"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_sheet, { class: "px-2 pt-3 pb-2 b-round-20" }, {
        default: _withCtx(() => [
          _createVNode(FormField, {
            modelValue: state.address_1,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.address_1) = $event)),
            editting: __props.edit,
            label: "Address 1",
            variant: "plain"
          }, null, 8, ["modelValue", "editting"]),
          _createVNode(FormField, {
            modelValue: state.address_2,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.address_2) = $event)),
            editting: __props.edit,
            label: "Address 2",
            variant: "outlined"
          }, null, 8, ["modelValue", "editting"]),
          _createVNode(FormField, {
            modelValue: state.address_3,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.address_3) = $event)),
            editting: __props.edit,
            label: "Address 3",
            variant: "outlined"
          }, null, 8, ["modelValue", "editting"]),
          _createVNode(FormField, {
            modelValue: state.city,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((state.city) = $event)),
            editting: __props.edit,
            label: "City",
            variant: "outlined"
          }, null, 8, ["modelValue", "editting"]),
          _createVNode(FormField, {
            modelValue: state.county,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((state.county) = $event)),
            editting: __props.edit,
            label: "County",
            variant: "outlined"
          }, null, 8, ["modelValue", "editting"]),
          _createVNode(FormField, {
            modelValue: state.country,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((state.country) = $event)),
            editting: __props.edit,
            label: "Country",
            variant: "outlined"
          }, null, 8, ["modelValue", "editting"]),
          _createVNode(FormField, {
            modelValue: state.post_code,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((state.post_code) = $event)),
            border: false,
            editting: __props.edit,
            label: "Post Code",
            variant: "outlined"
          }, null, 8, ["modelValue", "editting"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})